import type { ProjectFilter, TransformedProject } from "@/types";
import data from "./datafile";

export function find(filter: ProjectFilter): TransformedProject | undefined {
  return data.items.find(filter);
}
export function filter(filter: ProjectFilter): TransformedProject[] {
  return [...data.items].reverse().filter(filter);
}

const { emailData, translations, tags } = data;

export { emailData, tags, translations };
